import { Component, DEFAULT_CURRENCY_CODE, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
//import { DIGITALCATEGORY, DigitalCategoryDB } from 'src/app/shared/tables/digital-category';

import { GLOBAL } from "src/app/services/GLOBAL";
import { ProductoService } from 'src/app/services/producto.service';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';


import { NgForm } from '@angular/forms';
import { response } from 'express';
import { AdminService } from '../../../services/admin.service';
import { ClienteService } from '../../../services/cliente.service';

import iziToast from 'izitoast/dist/js/iziToast.min.js';

import { SortEvent } from 'src/app/shared/directives/shorting.directive';
import { NgbdSortableHeader } from "src/app/shared/directives/NgbdSortableHeader";
import { TableService } from 'src/app/shared/service/table.service';
import { Observable } from 'rxjs';
import { DecimalPipe } from '@angular/common';
import { OrderDB, ORDERDB } from 'src/app/shared/tables/order-list';


declare var $:any;
declare var iziToast;

@Component({
  selector: 'app-index-curso',
  templateUrl: './index-curso.component.html',
  //styleUrls: ['./index-curso.component.scss']
  providers: [TableService, DecimalPipe],

})
export class IndexCursoComponent implements OnInit {

  public closeResult: string;
  // tableItem$: Observable<DigitalCategoryDB[]>;
  // public digital_categories = []

  @ViewChild('closebutton') closebutton;

  public load_data = true;
  public filtro = '';
  public token;
  public productos : Array<any> = [];
  public arr_productos : Array<any> = [];
  public url;
  public page = 1;
  public pageSize = 20;

  public load_btn = false;

  constructor(
    private _productoService : ProductoService,
    private modalService: NgbModal,
    public service: TableService
  ) {
    this.token = localStorage.getItem('token');
    this.url = GLOBAL.url;    
   }

   @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;

  }

  ngOnInit(): void {
    this.init_data();
  }

  init_data(){
    this._productoService.listar_cursos_admin(this.filtro, this.token).subscribe(
      response=>{
        console.log(response);
        this.productos = response.data;
        this.productos.forEach(element => {
          this.arr_productos.push({
            titulo: element.titulo,            
            precio: element.precio,            
            nventas: element.nventas,
          });
        });
        console.log(this.arr_productos);
        

        this.load_data = false;
        
      },
      error=>{
        console.log(error);
        
      }
    )
  }

  filtrar(){
    if(this.filtro){
      this._productoService.listar_cursos_admin(this.filtro, this.token).subscribe(
        response=>{
          console.log(response);
          this.productos = response.data;
          this.load_data = false;
          
        },
        error=>{
          console.log(error);
          
        }
      )
    }else{
      iziToast.show({
          title: 'ERROR',
          titleColor: '#FF0000',
          color: '#FFF',
          class: 'text-danger',
          position: 'topRight',
          message: 'Los datos del formulario no son validos',        

      });
    }
  }

  resetear(){
    this.filtro = '';
    this.init_data();
  }

  eliminar(id){
    this.load_btn = true;
    this._productoService.eliminar_producto_admin(id,this.token).subscribe(
      response=>{
        iziToast.show({
            title: 'SUCCESS',
            titleColor: '#1DC74C',
            color: '#FFF',
            class: 'text-success',
            position: 'topRight',
            message: 'Se eliminó correctamente el producto.',        
        });

      this.modalService.dismissAll();
      this.load_btn = false;
      this.init_data();
        
      },
      error=>{
        iziToast.show({
            title: 'ERROR',
            titleColor: '#FF0000',
            color: '#FFF',
            class: 'text-danger',
            position: 'topRight',
            message: 'Ocurrió un error en el servidor.',        
        });
        console.log(error);
        this.load_btn = false;
        
      }
    )
  }

  download_excel(){
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Reporte de productos");

    worksheet.addRow(undefined);
    for (let x1 of this.arr_productos){
      let x2 = Object.keys(x1);

      let temp=[];
      for(let y of x2){
        temp.push(x1[y])
      }
      worksheet.addRow(temp)
    }

    let fname='REP01- ';

    worksheet.columns = [
      { header: 'Producto', key: 'col1', width: 30},      
      { header: 'Precio', key: 'col3', width: 15},      
      { header: 'N° ventas', key: 'col5', width: 15},
    ]as any;

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      fs.saveAs(blob, fname+'-'+new Date().valueOf()+'.xlsx');
    })
  }

  open(content) {    
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public onSave() {
    this.closebutton.nativeElement.click();
  }

  

}

